import { Icon } from "@components";
import { FC, useEffect, useState } from "react";

interface AlertProps {
    type?: "success" | "error" | "warning" | "info";
    message: string;
    onClose?: () => void;
    autoClose?: number;
    showCloseButton?: boolean;
}

export const Alert: FC<AlertProps> = ({ type = "info", message, onClose, autoClose, showCloseButton = false }) => {
    const [isVisible, setIsVisible] = useState(true);

    const alertClasses = {
        success: "alert alert-success",
        error: "alert alert-error",
        warning: "alert alert-warning",
        info: "alert alert-info",
    };

    const iconConfig = {
        success: { name: "CheckCircle", color: "#fff", strokeWidth: 2 },
        error: { name: "XCircle", color: "#fff", strokeWidth: 2 },
        warning: { name: "AlertTriangle", color: "#fff", strokeWidth: 2 },
        info: { name: "Info", color: "#fff", strokeWidth: 2 },
    };

    const { name, color, strokeWidth } = iconConfig[type];

    useEffect(() => {
        if (autoClose) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                if (onClose) onClose();
            }, autoClose);

            return () => clearTimeout(timer);
        }
    }, [autoClose, onClose]);

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) onClose();
    };

    if (!isVisible) return null;

    return (
        <div
            role="alert"
            className={`flex items-center gap-2 p-4 rounded-lg shadow-md ${alertClasses[type]}`}
        >
            <Icon
                iconName={name as any}
                size={20}
                color={color}
                strokeWidth={strokeWidth}
            />
            <span>{message}</span>
            {
                showCloseButton && (
                    <button
                        className="ml-auto text-white hover:text-gray-200"
                        onClick={handleClose}
                        aria-label="Close"
                    >
                        <Icon iconName="X" size={20} color={color} strokeWidth={2} />
                    </button>
                )
            }
        </div>
    );
};
